/**
 * Vuex store modules names grouped in creation order
 */
 export const storeModulesGroups = {
    // These modules declared at store creation and can not be deleted after with unregisterModule
   default: [
     'alerts', // alerts in monitoring, compute
     'compute', // common compute info
     'computeNodes',
     'domains', // settings tree of domains users projects
     'domainProps',
     'errors', // application errors
     'ha',
     'locationNames',
     'locations',
     'nodesDisks',
     'nodesFiberChannel',
     'nodesInterfaces',
     'nodesISCSIDisks',
     'notifications',
     'occupiedFailureDomains',
     'problemReport', // ui menu report
     'projects',
     'reconfiguration',
     'rolesets',
     'certificate',
     'settings',
     'socket',
     'updates',
   ],
    // dynamic modules that must be created after user is logged in and removed or cleared after logged out
   authorized: [
     'nodes',
     'projects',
     'tasks', // backend tasks
   ],
   monitoring: [
     'activities',
   ],
   compute: [
     'computeNodes', // Used in websocket notification's
      // 'lbaas',
     'networks',
     'securityGroups',
     'servers',
     'subnets',
     'vpn'
   ],
   computeNodes: [
     'computeNodes',
     'nodes',
     'rolesets'
   ],
    // TODO separate hci and selfservice static store modules
   selfservice: [
     'domainProps',
     'ui',
     'vpn'
   ],
   settings: [
     'ha', // TODO check
     'dns', // TODO check
     'nodes',
     'updates',
     'kerberos',
     'nfsLdapSettings',
     'managementNodeBackup',
     'sslSettings',
   ],
   storage: [
     'iscsi', // TODO check
     's3Users',
     's3Buckets',
     'nodes',
   ],
   infrastructure: [
     'nodes', // infrastructure nodes
     'rolesets', // infrastructure rolesets
   ]
 };

 export default storeModulesGroups;
